/* eslint-disable import/prefer-default-export */
export const CORRECT_CONFIRMATION_TEXT = 'deactivate me';
export const CORRECT_CONFIRMATION_REGEX = /^deactivate me$/i;